import { addressHelpers } from "../../../../../features/address"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { DetailFieldProps, DetailPanel, FieldType, UIPermission, useGetCrumbs } from "../../../../../features/ui"
import { TableName } from "../../../../../tables"
import { useSystemStateHooks } from "../../../../system"
import { Branch } from "../../../state/types"

export const BranchDetail = () => {
  const { dataType } = useRoutesHooks().parseUrl()
  const branch = dataType! as Branch
  const { address, ...data } = branch

  const { describeAddress } = addressHelpers
  const { userHasPermission } = useSystemStateHooks()
  const readOnly = !userHasPermission(UIPermission.SAVE_BRANCHES)

  const crumbs = useGetCrumbs(
    'Sucursales',
    RoutePath.BRANCHES,
    branch.name
  )

  const fields: DetailFieldProps[] = [
    {
      name: 'code',
      type: FieldType.TEXT,
      label: 'Código'
    },
    {
      name: 'name',
      type: FieldType.TEXT,
      label: 'Nombre'
    },
    {
      name: 'address',
      type: FieldType.TEXT,
      label: 'Dirección',
      render: () => <>{describeAddress(branch.address)}</>
    }
  ]

  return (<>
    <DetailPanel
      tableName={TableName.BRANCHES}
      crumbs={crumbs}
      fields={fields}
      data={data}
      icon='building'
      readOnly={readOnly}
    />
  </>)
}
